.card {
  margin-bottom: 16px;
}

.header {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--ant-color-border-secondary);
}

.basicInfo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.requestId {
  font-family: Consolas, Monaco, monospace;
  color: var(--ant-color-primary);
  overflow-wrap: anywhere;
}

.model {
  font-family: Consolas, Monaco, monospace;
  color: var(--ant-color-text-secondary);
}

.json {
  max-height: 500px;
  padding: 12px;
  margin: 0;
  overflow: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: var(--ant-color-text);
  overflow-wrap: break-word;
  white-space: pre-wrap;
  background: var(--ant-color-fill-quaternary);
  border-radius: var(--ant-border-radius-sm);
}
